<script setup>

import notification from "@/utils/plugins/NotificationService";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";

import TicketService from "@/api/services/ticket.service";
import Api from "@/api/Api";
import { useUiStore } from "@/app/stores/uiStore";
import TicketForm from "@/views/internal-tickets/InternalTicketForm.vue";
import router from "@/app/router/router";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


const route = useRoute()
const ticket = ref(null)
const isSubmitting = ref(false)
const uiStore = useUiStore()

onMounted(async () => {
  await getTicket();
})


const getTicket = async () => {
  uiStore.startLoading();
  try {
    const response = await Api().get('/api/tickets/' + route.params.id);
    ticket.value = response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      notification.addNotification('El ticket ya no está disponible para tu usuario.', 'info', 6000);
      router.push({ name: 'internal_tickets' });
    } else {
      notification.addNotification(error.response?.data?.detail || 'No se ha podido cargar el ticket.', 'error', 6000);
    }
  } finally {
    uiStore.stopLoading();
  }
}

const updateTicket = async (form) => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  const formTicket = JSON.parse(JSON.stringify(form));
  const iri = value => value && typeof value === 'object' ? value['@id'] : value;
  formTicket.ticketType = iri(form.ticketType) || null;
  formTicket.ticketPriority = iri(form.ticketPriority) || null;
  formTicket.department = iri(form.department) || null;
  formTicket.assignedEmployee = iri(form.assignedEmployee) || null;
  formTicket.project = iri(form.project) || null;
  formTicket.internal = true;
  if (formTicket.client == 12) {
    formTicket.requestingEmployee = iri(formTicket.requestingUser) || formTicket.requestingEmployee || null;
    formTicket.affectedEmployee = iri(formTicket.affectedUser) || formTicket.affectedEmployee || null;
    delete formTicket.requestingUser;
    delete formTicket.affectedUser;
  } else {
    formTicket.requestingUser = iri(formTicket.requestingUser) || null;
    formTicket.affectedUser = iri(formTicket.affectedUser) || null;
  }
  delete formTicket.status;
  delete formTicket.ticketStatus;
  delete formTicket.daysOpen;
  delete formTicket.comments;
  delete formTicket.ticketStatusHistories;
  delete formTicket.assignmentHistories;
  delete formTicket.ticketDocuments;
  uiStore.startLoading();
  try {
    const response = await Api().put('/api/tickets/' + ticket.value.id, formTicket);
    notification.addNotification({
      title: 'Ticket actualizado', message: 'Ticket ' + response.data.tag + '-' + response.data.id + ' actualizado con éxito',
      type: 'success', duration: 10000,
    });
    // Volver al listado también cubre al asignado anterior que pierde acceso.
    router.push({ name: 'internal_tickets' });
  } catch (error) {
    notification.addNotification({
      title: 'Error', message: error.response?.data?.detail || error.response?.data?.message || 'No se ha podido guardar el ticket.',
      type: 'error', duration: 6000,
    });
  } finally {
    uiStore.stopLoading();
    isSubmitting.value = false;
  }
}

const updateProject = (form) => {
  const project = form.project;
  const params = {
    "project": project
  }
  TicketService.updateTicket(params, ticket.value.id).then((res) => {
    console.log(res.data);
    ticket.value = res.data;
  });

}

</script>

<template>
  <div>
    <HeaderTitle title="Comunicación" />

    <TicketForm v-if="ticket" action="update" :ticket="ticket" :isSubmitting="isSubmitting" @saveData="updateTicket"
      @get-ticket="getTicket" @updateProject="updateProject" />
  </div>
</template>

<style scoped></style>
